export default function formatStorage(value) {
  const toFixed = (val) => val.toFixed(2);
  let storage = 0;
  let unit = "B";
  if (value < 1024) {
    unit = "B";
    storage = value;
  } else if (value < 1048576) {
    unit = "KB";
    storage = toFixed(value / 1024);
  } else if (value < 1073741824) {
    unit = "M";
    storage = toFixed(value / 1048576);
  } else if (value < 1099511627776) {
    unit = "G";
    storage = toFixed(value / 1073741824);
  } else if (value < 1125899906842624) {
    unit = "T";
    storage = toFixed(value / 1099511627776);
  }
  return { storage: Number(storage), unit, origin: value };
}
